import React from 'react';
import { Link } from 'react-router-dom';
import { h5 } from 'scy/text/styles.mod.scss';
import Breadcrumbs from 'scy/Breadcrumbs';
import ProductSummary from './summary';
import { LargeProductImage } from 'scy/ProductImage';
import Card from 'scy/Card';
import ProductInfoRecommendations from './ProductInfoRecommendations';
import styles from './styles.mod.scss';

export default function ProductInfo({
  product,
  loading,
  brandName,
  parentCategories,
  moreByBrand,
  moreByBrandLoading,
  boughtWith,
  boughtWithLoading,
  previewingProduct,
  ratingValue,
  ratingCount
}) {
  return (
    <Card tag="section" className={styles.productInfoCard}>
      <div className={styles.productInfoLeftColumn}>
        <LargeProductImage
          product={product}
          loading={loading}
          className={styles.image}
          alt={!loading ? product.title : null}
        />

        {moreByBrand.length ? (
          <ProductInfoRecommendations
            title={
              product.brandUrl ? (
                <Link to={product.brandUrl}>More By {brandName}</Link>
              ) : null
            }
            products={moreByBrand}
            loading={!previewingProduct && moreByBrandLoading}
          />
        ) : (
          <ProductInfoRecommendations
            title="Often Bought With"
            products={boughtWith}
            loading={!previewingProduct && boughtWithLoading}
          />
        )}
      </div>

      <div className={styles.breadcrumbsContainer}>
        {!loading && (
          <Breadcrumbs
            className={h5}
            product={product}
            parentCategories={parentCategories}
          />
        )}
      </div>

      <ProductSummary
        product={product}
        loading={loading}
        loadingDetails={previewingProduct}
        ratingValue={ratingValue}
        ratingCount={ratingCount}
      />
    </Card>
  );
}
